export default "__VITE_ASSET__km7dQy2K__"